import { Edit } from "../../../../UI.BaseControls/Edit";
import { NumEdit } from "../../../../UI.BaseControls/NumEdit";
import { TimeEdit } from "../../../../UI.BaseControls/TimeEdit";
import { DateTimeWithInclude } from "./AdvancedFilters/DateTimeWithInclude";
import { DateWithInclude } from "./AdvancedFilters/DateWithInclude";
import { DaysListAdvancedFilter } from "./AdvancedFilters/DaysListAdvancedFilter";
import { EnumFilterEdit } from "./AdvancedFilters/EnumFilterEdit";
import { EnumValueListButton } from "./AdvancedFilters/EnumValueListButton";
import { ExtendedFilterEdit } from "./AdvancedFilters/ExtendedFilterEdit";
import { FlagFilter } from "./AdvancedFilters/FlagFilter";
import { IconValueListButton } from "./AdvancedFilters/IconValueListButton";
import { MonthListAdvancedFilter } from "./AdvancedFilters/MonthListAdvancedFilter";
import { MultiValueEdit } from "./AdvancedFilters/MultiValueEdit";
import { QuarterListAdvancedFilter } from "./AdvancedFilters/QuarterListAdvancedFilter";
import { TimeAgeCombo } from "./AdvancedFilters/TimeAgeCombo";
import { ValueListButton } from "./AdvancedFilters/ValueListButton";
import { FilterConvertFunction, FilterEmptyType } from "./FilterInterfaces";
import { FilterRegistrations } from "./FilterRegistrations";

const timeFromJsonFormatter = (datetime: string) => new Date(datetime).toTimeString(); //funkce, které se použije při parsování datového typu "time" z JSON, kde je uložen celý dateTime, ale TimeEdit počítá jen s TimeStringem

//#region Registrace struktur
//#region Základní registrace fieldu
//Structure.RegisterField("DateTimeEdit", DateTimeEdit, undefined,
FilterRegistrations.registerField("DateTimeEdit", DateTimeWithInclude, undefined, undefined,
    (v: any, type: FilterConvertFunction): string => {
        if (type == FilterConvertFunction.sql) {
            //return v.toISOString().slice(0, 19).replace('T', ' ');
            if (!v)
                return null;
            return v.getFullYear() + "-" +
                ("00" + (v.getMonth() + 1)).slice(-2) + "-" +
                ("00" + v.getDate()).slice(-2) + "T" +
                ("00" + v.getHours()).slice(-2) + ":" +
                ("00" + v.getMinutes()).slice(-2) + ":" +
                ("00" + v.getSeconds()).slice(-2);
        }
        return v;
    });
FilterRegistrations.registerField("TimeEdit", TimeEdit, undefined, undefined,
    (v: any, type: FilterConvertFunction): string => {
        if (type == FilterConvertFunction.sql) {
            //return v.toISOString().slice(0, 19).replace('T', ' ');
            if (!v)
                return null;
            return ("00" + v.getHours()).slice(-2) + ":" +
                ("00" + v.getMinutes()).slice(-2) + ":" +
                ("00" + v.getSeconds()).slice(-2);
        }
        return v;
    });
FilterRegistrations.registerField("DateEdit", DateWithInclude, undefined, undefined,
    (v: any, type: FilterConvertFunction): string => {
        if (type == FilterConvertFunction.sql) {
            //return v.toISOString().slice(0, 10).replace('T', ' ');
            if (!v)
                return null;
            return v.getFullYear() + "-" +
                ("00" + (v.getMonth() + 1)).slice(-2) + "-" +
                ("00" + v.getDate()).slice(-2);
        }
        return v;
    });
FilterRegistrations.registerField("Edit", Edit);
FilterRegistrations.registerField("EnumEdit", EnumFilterEdit);
FilterRegistrations.registerField("NumEdit", NumEdit, (control: NumEdit) => control.innerElement.setAttribute("displayformat", ""));
FilterRegistrations.registerField("IntEdit", NumEdit, (control: NumEdit) => {
    control.wholeNumbers = true; control.customValidation = (value => value > 0);
});
FilterRegistrations.registerField("Boolean", undefined);
FilterRegistrations.registerField("TimeAgeCombo", TimeAgeCombo);
FilterRegistrations.registerField("TimeAgeComboForInThisOption", TimeAgeCombo, (control: TimeAgeCombo) => control.setLocalizationsForInThisOption());
FilterRegistrations.registerField("DaysListAdvancedFilter", DaysListAdvancedFilter);
FilterRegistrations.registerField("MonthListAdvancedFilter", MonthListAdvancedFilter);
FilterRegistrations.registerField("QuarterListAdvancedFilter", QuarterListAdvancedFilter);
FilterRegistrations.registerField("MultiValueEdit", MultiValueEdit);
FilterRegistrations.registerField("ValueListButton", ValueListButton);
FilterRegistrations.registerField("EnumValueListButton", EnumValueListButton);
FilterRegistrations.registerField("IconValueListButton", IconValueListButton);
FilterRegistrations.registerField("FlagFilter", FlagFilter);
FilterRegistrations.registerField("ExtendedFilterEdit", ExtendedFilterEdit);

//#endregion Základní registrace fieldu

//#region Registrace struktury Date
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation("date", {
    "is": {
        inputs: {
            "input1": { condition: "{attrName} = {value}" },
        },
    },
    "not_is": {
        inputs: {
            "input1": { condition: "{attrName} <> {value}" },
        },
    },
    "after": {
        inputs: {
            "input1": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" } },
        },
    },
    "before": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
        },
    },
    "in_range": {
        inputs: {
            "input1": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" } },
            "input2": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" }, sign: "and" },
        },
    },
    "not_in_range": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
            "input2": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" }, sign: "or" },
        },
    },
    "today": {
        beginCondition: "{attrName} = DB.GetDate()",
        noBeginValueParameters: true,
    },
    "tomorrow": {
        beginCondition: "{attrName} = DBDate.DateAdd('day', 1, 'SYSDATE')",
        noBeginValueParameters: true,
    },
    "yesterday": {
        beginCondition: "{attrName} = DBDate.DateAdd('day', -1, 'SYSDATE')",
        noBeginValueParameters: true,
    },
    "in_the_next": {
        beginCondition: "{attrName} > DB.GetDate() AND {attrName} <= DBDate.DateAdd('{value:input2}', {value:input15}, 'SYSDATE')", //DBDate.DateAdd({value:input2}, 1, 'SYSDATE')
    },
    "in_past": {
        beginCondition: "{attrName} >= DBDate.DateAdd('{value:input2}', -{value:input15}, 'SYSDATE') AND {attrName} < DB.GetDate()", //DBDate.DateAdd({value:input2}, -1, 'SYSDATE')
    },
    "in_this": {
        beginCondition: "DBDate.DatePart('{value:input2}', {attrName}) = DBDate.DatePart('{value:input2}', 'SYSDATE')",
    },
    "days": {
        beginCondition: "DBDate.DatePart('weekday', {attrName}) ∈ { {value:input3} }",
    },
    "months": {
        beginCondition: "DBDate.DatePart('month', {attrName}) ∈ { {value:input4} }",
    },
    "quarter": {
        beginCondition: "DBDate.DatePart('quarter', {attrName}) ∈ { {value:input5} }",
    },
    "weeks": {
        beginCondition: "DBDate.DatePart('week', {attrName}) ∈ { {value:input6} }",
    },
    "years": {
        beginCondition: "DBDate.DatePart('year', {attrName}) ∈ { {value:input6} }",
    },
    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "date",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-146850", [// Je
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit"),
                ]),
                FilterRegistrations.getIOperation("not_is", "GUI-146852", [// Není
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit"),
                ]),
                FilterRegistrations.getIOperation("after", "GUI-452752", [// Po
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit", { including: true }),
                ]),
                FilterRegistrations.getIOperation("before", "GUI-452750", [// Před
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit", { including: true }),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("in_range", "GUI-280032", [// V rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit", { including: true }),
                    FilterRegistrations.getIFilterFieldInfo("input2", "DateEdit", { including: true }),
                ]),
                FilterRegistrations.getIOperation("not_in_range", "GUI-598878", [// Mimo rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateEdit", { including: true }),
                    FilterRegistrations.getIFilterFieldInfo("input2", "DateEdit", { including: true }),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("tomorrow", "GUI-598879"), // Zítra
                FilterRegistrations.getIOperation("today", "GUI-452754"), // Dnes
                FilterRegistrations.getIOperation("yesterday", "GUI-452756"), // Včera
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("in_the_next", "GUI-598880", [// V přístích
                    FilterRegistrations.getIFilterFieldInfo("input15", "IntEdit"),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeCombo"),
                ]),
                FilterRegistrations.getIOperation("in_this", "GUI-598881", [// V tomto
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeComboForInThisOption"),
                ]),
                FilterRegistrations.getIOperation("in_past", "GUI-598882", [// V minulých
                    FilterRegistrations.getIFilterFieldInfo("input15", "IntEdit"),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeCombo"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("days", "GUI-598883", [// Dny
                    FilterRegistrations.getIFilterFieldInfo("input3", "DaysListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("weeks", "GUI-86328", [// Týdny
                    FilterRegistrations.getIFilterFieldInfo("input6", "MultiValueEdit", undefined, (value: string) => value.replace(/,/g, ";")),
                ]),
                FilterRegistrations.getIOperation("months", "GUI-86326", [// Měsíce
                    FilterRegistrations.getIFilterFieldInfo("input4", "MonthListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("quarter", "GUI-598884", [// Čtvrtletí
                    FilterRegistrations.getIFilterFieldInfo("input5", "QuarterListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("years", "GUI-86324", [// Roky
                    FilterRegistrations.getIFilterFieldInfo("input6", "MultiValueEdit", undefined, (value: string) => value.replace(/,/g, ";")),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
    ],
});
//#endregion Registrace struktury Date

//#region Registrace struktury DateTime
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation("datetime", {
    "is": {
        inputs: {
            "input1": { condition: "{attrName} >= {value} AND {attrName} < DBDate.DateAdd('{span}', 1, {value})", span: "second" },
        },
        subOperation: {
            "day": {
                inputs: {
                    "input1": { condition: "{attrName} >= {value} AND {attrName} < DBDate.DateAdd('day', 1, {value})" },
                },
            },
        },
    },
    "not_is": {
        inputs: {
            "input1": { condition: "{attrName} < {value} OR {attrName} >= DBDate.DateAdd('{span}', 1, {value})", span: "second" },
        },
        subOperation: {
            "day": {
                inputs: {
                    "input1": { condition: "{attrName} < {value} OR {attrName} >= DBDate.DateAdd('day', 1, {value})" },
                },
            },
        },
    },
    "after": {
        inputs: {
            "input1": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" }, span: "second" },
        },
    },
    "before": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
        },
    },
    "in_range": {
        inputs: {
            "input1": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" } },
            "input2": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" }, sign: "and" },
        },
    },
    "not_in_range": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
            "input2": { condition: "{attrName} > {value}", additional: { including: "{attrName} >= {value}" }, sign: "or" },
        },
    },
    "today": {
        beginCondition: "{attrName} >= DBDate.DateAdd('day', 0, 'SYSDATE') AND {attrName} < DBDate.DateAdd('day', 1, 'SYSDATE')",
        noBeginValueParameters: true,
    },
    "tomorrow": {
        beginCondition: "{attrName} >= DBDate.DateAdd('day', 1, 'SYSDATE') AND {attrName} < DBDate.DateAdd('day', 2, 'SYSDATE')",
        noBeginValueParameters: true,
    },
    "yesterday": {
        beginCondition: "{attrName} >= DBDate.DateAdd('day', -1, 'SYSDATE') AND {attrName} < DBDate.DateAdd('day', 0, 'SYSDATE')",
        noBeginValueParameters: true,
    },
    "in_the_next": {
        beginCondition: "{attrName} > DB.GetDateTime() AND {attrName} < DBDate.DateAdd('{value:input2}', {value:input15}, DB.GetDateTime())",
    },
    "in_past": {
        beginCondition: "{attrName} > DBDate.DateAdd('{value:input2}', -{value:input15}, DB.GetDateTime()) AND {attrName} < DB.GetDateTime()",
    },
    "in_this": {
        beginCondition: "DBDate.DatePart('{value:input2}', {attrName}) = DBDate.DatePart('{value:input2}', 'SYSDATE')",
    },
    "days": {
        beginCondition: "DBDate.DatePart('weekday', {attrName}) ∈ { {value:input3} }",
    },
    "months": {
        beginCondition: "DBDate.DatePart('month', {attrName}) ∈ { {value:input4} }",
    },
    "quarter": {
        beginCondition: "DBDate.DatePart('quarter', {attrName}) ∈ { {value:input5} }",
    },
    "weeks": {
        beginCondition: "DBDate.DatePart('week', {attrName}) ∈ { {value:input6} }",
    },
    "years": {
        beginCondition: "DBDate.DatePart('year', {attrName}) ∈ { {value:input6} }",
    },
    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "datetime",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-146850", [// Je
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: false }),
                ]),
                FilterRegistrations.getIOperation("not_is", "GUI-146852", [// Není
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: false }),
                ]),
                FilterRegistrations.getIOperation("after", "GUI-452752", [// Po
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: true }),
                ]),
                FilterRegistrations.getIOperation("before", "GUI-452750", [// Před
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: true, defaultValue: "00:00:00" }),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("in_range", "GUI-280032", [// V rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: true }),
                    FilterRegistrations.getIFilterFieldInfo("input2", "DateTimeEdit", { including: true, defaultValue: "00:00:00" }),
                ]),
                FilterRegistrations.getIOperation("not_in_range", "GUI-598878", [// Mimo rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "DateTimeEdit", { including: true, defaultValue: "23:59:59" }),
                    FilterRegistrations.getIFilterFieldInfo("input2", "DateTimeEdit", { including: true }),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("tomorrow", "GUI-598879"), // Zítra
                FilterRegistrations.getIOperation("today", "GUI-452754"), // Dnes
                FilterRegistrations.getIOperation("yesterday", "GUI-452756"), // Včera
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("in_the_next", "GUI-598880", [// V přístích
                    FilterRegistrations.getIFilterFieldInfo("input15", "IntEdit"),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeCombo"),
                ]),
                FilterRegistrations.getIOperation("in_this", "GUI-598881", [// V tomto
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeComboForInThisOption"),
                ]),
                FilterRegistrations.getIOperation("in_past", "GUI-598882", [// V minulých
                    FilterRegistrations.getIFilterFieldInfo("input15", "IntEdit"),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeAgeCombo"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("days", "GUI-598883", [// Dny
                    FilterRegistrations.getIFilterFieldInfo("input3", "DaysListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("weeks", "GUI-86328", [// Týdny
                    FilterRegistrations.getIFilterFieldInfo("input6", "MultiValueEdit", undefined, (value: string) => value.replace(/,/g, ";")),
                ]),
                FilterRegistrations.getIOperation("months", "GUI-86326", [// Měsíce
                    FilterRegistrations.getIFilterFieldInfo("input4", "MonthListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("quarter", "GUI-598884", [// Čtvrtletí
                    FilterRegistrations.getIFilterFieldInfo("input5", "QuarterListAdvancedFilter"),
                ]),
                FilterRegistrations.getIOperation("years", "GUI-86324", [// Roky
                    FilterRegistrations.getIFilterFieldInfo("input6", "MultiValueEdit", undefined, (value: string) => value.replace(/,/g, ";")),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
    ],
});
//#endregion Registrace struktury DateTime

//#region Registrace struktury Time
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation("time", {
    "is": {
        inputs: {
            "input1": { condition: "{attrName} >= {value} AND {attrName} < DBDate.DateAdd('{span}', 1, {value})", span: "second" },
        },
    },
    "not_is": {
        inputs: {
            "input1": { condition: "{attrName} < {value} OR {attrName} >= DBDate.DateAdd('{span}', 1, {value})", span: "second" },
        },
    },
    "after": {
        inputs: {
            "input1": { condition: "{attrName} >= DBDate.DateAdd('{span}', 1, {value})", additional: { including: "{attrName} >= {value}" }, span: "second" },
        },
    },
    "before": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
        },
    },
    "in_range": {
        inputs: {
            "input1": { condition: "{attrName} >= {value}", additional: { including: "{attrName} >= {value}" } },
            "input2": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" }, sign: "and" },
        },
    },
    "not_in_range": {
        inputs: {
            "input1": { condition: "{attrName} < {value}", additional: { including: "{attrName} <= {value}" } },
            "input2": { condition: "{attrName} >= {value}", additional: { including: "{attrName} >= {value}" }, sign: "or" },
        },
    },
    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "time",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-146850", [// Je
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: false }, timeFromJsonFormatter),
                ], undefined, true),
                FilterRegistrations.getIOperation("not_is", "GUI-146852", [// Není
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: false }, timeFromJsonFormatter),
                ]),
                FilterRegistrations.getIOperation("after", "GUI-452752", [// Po
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: true }, timeFromJsonFormatter),
                ]),
                FilterRegistrations.getIOperation("before", "GUI-452750", [// Před
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: true }, timeFromJsonFormatter),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("in_range", "GUI-280032", [// V rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: true }, timeFromJsonFormatter),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeEdit", { including: true }, timeFromJsonFormatter),
                ]),
                FilterRegistrations.getIOperation("not_in_range", "GUI-598878", [// Mimo rozmezí
                    FilterRegistrations.getIFilterFieldInfo("input1", "TimeEdit", { including: true }, timeFromJsonFormatter),
                    FilterRegistrations.getIFilterFieldInfo("input2", "TimeEdit", { including: true }, timeFromJsonFormatter),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
    ],
});
//#endregion Registrace struktury Time
//#region Registrace struktury String
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation(["string", "strnum", "text"], {
    "is": {
        inputs: {
            "input1": {
                condition: ":Linguistic.Equal({attrName},'{value}')",
                escapeValue: false,
                conditionalOperation: [
                    { containsValue: "*", condition: ":Linguistic.LIKE({attrName},'{value}')", isForReplace: true },
                    { containsValue: "?", condition: ":Linguistic.LIKE({attrName},'{value}')", isForReplace: true },
                ],
            },
        },
    },
    "not_is": {
        inputs: {
            "input1": {
                condition: "NOT :Linguistic.Equal({attrName},'{value}')",
                escapeValue: false,
                conditionalOperation: [
                    { containsValue: "*", condition: "NOT :Linguistic.LIKE({attrName},'{value}')", isForReplace: true },
                    { containsValue: "?", condition: "NOT :Linguistic.LIKE({attrName},'{value}')", isForReplace: true },
                ],
            },
        },
    },
    "start_with": {
        inputs: {
            "input1": { condition: ":Linguistic.LIKE({attrName},'{value}%')" },
        },
    },
    "not_start_with": {
        inputs: {
            "input1": { condition: "NOT :Linguistic.LIKE({attrName},'{value}%')" },
        },
    },
    "end_with": {
        inputs: {
            "input1": { condition: ":Linguistic.LIKE({attrName},'%{value}')" },
        },
    },
    "not_end_with": {
        inputs: {
            "input1": { condition: "NOT :Linguistic.LIKE({attrName},'%{value}')" },
        },
    },
    "contain": {
        inputs: {
            "input1": { condition: ":Linguistic.LIKE({attrName},'%{value}%')" },
        },
    },
    "not_contain": {
        inputs: {
            "input1": { condition: "NOT :Linguistic.LIKE({attrName},'%{value}%')" },
        },
    },
    "value_is": {
        beginCondition: "{attrName} ∈ { {value:input6} }",
        useForShortenedValues: false,
        inputs: {
            "input6": {
                condition: ":Linguistic.LIKE({attrName},'{value}%')", useForShortenedValues: true, signForBeginCondition: "or",
            },
        },
    },
    "value_not_is": {
        beginCondition: "{attrName} ∉ { {value:input6} }",
        useForShortenedValues: false,
        inputs: {
            "input6": {
                condition: "NOT :Linguistic.LIKE({attrName},'{value}%')", useForShortenedValues: true, signForBeginCondition: "or",
            },
        },
    },
    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerMultiTypeFilter({
    dataType: "string",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-146850", [// Je
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("not_is", "GUI-146852", [// Není
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("start_with", "GUI-452738", [// Začíná
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ], undefined, true),
                FilterRegistrations.getIOperation("not_start_with", "GUI-598885", [// Nezačíná
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("end_with", "GUI-280002", [// Končí
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("not_end_with", "GUI-598955", [// Nekončí
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("contain", "GUI-452736", [// Obsahuje
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
                FilterRegistrations.getIOperation("not_contain", "GUI-279998", [// Neobsahuje
                    FilterRegistrations.getIFilterFieldInfo("input1", "Edit"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("value_is", "GUI-598886", [// Hodnoty jsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "ValueListButton"),
                ]),
                FilterRegistrations.getIOperation("value_not_is", "GUI-598887", [// Hodnoty nejsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "ValueListButton"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("extended", "GUI-685188", [// Rozšířené
                    FilterRegistrations.getIFilterFieldInfo("input6", "ExtendedFilterEdit"),
                ]),
            ],
        },
    ],
}, FilterRegistrations.stringTypes);
//#endregion Registrace struktury String

//#endregion Registrace struktury Icon
FilterRegistrations.registerServerOperation("icon", {
    "value_is": {
        beginCondition: "{attrName} ∈ { {value:input6} }",
    },
    "value_not_is": {
        beginCondition: "{attrName} ∉ { {value:input6} }",
    },

    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});

FilterRegistrations.registerDataTypeFilter({
    dataType: "icon",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("value_is", "GUI-598886", [ // Hodnoty jsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "IconValueListButton"),
                ]),
                FilterRegistrations.getIOperation("value_not_is", "GUI-598887", [ // Hodnoty nejsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "IconValueListButton"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
    ],
});
//#endregion Registrace struktury Icon

//#region Registrace struktury Enum
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation("enum", {
    "is": {
        inputs: {
            "input1": { condition: "{attrName} ∈ { {value} }" },
        },
    },
    "not_is": {
        inputs: {
            "input1": { condition: "{attrName} ∉ { {value} }" },
        },
    },
    "start_with": {
        inputs: {
            "input1": { condition: "{attrName} ∈ { {value} }" },
        },
    },
    "not_start_with": {
        inputs: {
            "input1": { condition: "{attrName} ∉ { {value} }" },
        },
    },
    "end_with": {
        inputs: {
            "input1": { condition: "{attrName} ∈ { {value} }" },
        },
    },
    "not_end_with": {
        inputs: {
            "input1": { condition: "{attrName} ∉ { {value} }" },
        },
    },
    "contain": {
        inputs: {
            "input1": { condition: "{attrName} ∈ { {value} }" },
        },
    },
    "not_contain": {
        inputs: {
            "input1": { condition: "{attrName} ∉ { {value} }" },
        },
    },
    "value_is": {
        beginCondition: "{attrName} ∈ { {value:input6} }",
    },
    "value_not_is": {
        beginCondition: "{attrName} ∉ { {value:input6} }",
    },

    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "enum",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-146850", [// Je
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("not_is", "GUI-146852", [// Není
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("start_with", "GUI-452738", [// Začíná
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ], undefined, true),
                FilterRegistrations.getIOperation("not_start_with", "GUI-598885", [// Nezačíná
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("end_with", "GUI-280002", [// Končí
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("not_end_with", "GUI-598955", [// Nekončí
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("contain", "GUI-452736", [// Obsahuje
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
                FilterRegistrations.getIOperation("not_contain", "GUI-279998", [// Neobsahuje
                    FilterRegistrations.getIFilterFieldInfo("input1", "EnumEdit"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("value_is", "GUI-598886", [ // Hodnoty jsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "EnumValueListButton"),
                ]),
                FilterRegistrations.getIOperation("value_not_is", "GUI-598887", [ // Hodnoty nejsou
                    FilterRegistrations.getIFilterFieldInfo("input6", "EnumValueListButton"),
                ]),
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("extended", "GUI-685188", [// Rozšířené
                    FilterRegistrations.getIFilterFieldInfo("input6", "ExtendedFilterEdit"),
                ]),
            ],
        },
    ],
});
//#endregion Registrace struktury Enum

//#region Registrace struktury Number
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation(FilterRegistrations.numericTypes, {
    "is_equal": {
        inputs: {
            "input1": { condition: "{attrName} = {value}" },
        },
    },
    "not_is_equal": {
        inputs: {
            "input1": { condition: "{attrName} <> {value}" },
        },
    },
    "greater_than": {
        inputs: {
            "input1": { condition: "{attrName} > {value}" },
        },
    },
    "greater_or_equal_than": {
        inputs: {
            "input1": { condition: "{attrName} >= {value}" },
        },
    },
    "less_than": {
        inputs: {
            "input1": { condition: "{attrName} < {value}" },
        },
    },
    "less_or_equal_than": {
        inputs: {
            "input1": { condition: "{attrName} <= {value}" },
        },
    },
    "is_empty": {
        emptyFilter: FilterEmptyType.empty,
    },
    "is_not_empty": {
        emptyFilter: FilterEmptyType.notEmpty,
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerMultiTypeFilter({
    dataType: "integer",
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is_equal", "GUI-598888", [// Je rovno
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599242"), // =
                FilterRegistrations.getIOperation("not_is_equal", "GUI-598889", [// Není rovno
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599241"), // ≠
                FilterRegistrations.getIOperation("greater_than", "GUI-280018", [// Větší než
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599243"), // >
                FilterRegistrations.getIOperation("greater_or_equal_than", "GUI-598891", [// Větší nebo rovno než
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599244"), // ≥
                FilterRegistrations.getIOperation("less_than", "GUI-280020", [// Menší než
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599245"), // <
                FilterRegistrations.getIOperation("less_or_equal_than", "GUI-598890", [// Menší nebo rovno než
                    FilterRegistrations.getIFilterFieldInfo("input1", "NumEdit"),
                ], undefined, undefined, undefined, "GUI-599246"), // ≤
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("is_empty", "GUI-487654"), // Je prázdný
                FilterRegistrations.getIOperation("is_not_empty", "GUI-487656"), // Není prázdný
            ],
        },
        {
            operationList: [
                FilterRegistrations.getIOperation("extended", "GUI-685188", [// Rozšířené
                    FilterRegistrations.getIFilterFieldInfo("input6", "ExtendedFilterEdit"),
                ]),
            ],
        },
    ],
}, FilterRegistrations.numericTypes);
//#endregion Registrace struktury Number

//#region Registrace struktury Boolean
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation(["Boolean"], {
    "boolean": {
        "inputs": {
            "true": {
                condition: "{attrName} = {value}",
            },
            "false": {
                condition: "{attrName} = {value}",
            },
            "is_empty": {
                condition: "{attrName} = NULL",
            },
            "is_not_empty": {
                condition: "{attrName} <> NULL",
            },
        },
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "boolean",
    groupList: [],
    multiOperation: {
        id: "boolean",
        groupList: [
            {
                operationList: [
                    FilterRegistrations.getIMultiOperation("true", "GUI-146844", "true", "✔"), // Pravda
                    FilterRegistrations.getIMultiOperation("false", "GUI-146846", "false", "✖"), // Nepravda
                ],
            },
            {
                operationList: [
                    FilterRegistrations.getIMultiOperation("is_empty", "GUI-487654", "", "GUI-487654"), // Nevyplněno
                    FilterRegistrations.getIMultiOperation("is_not_empty", "GUI-487656", "", "GUI-487656"), // Vyplněno
                ],
            },
        ],
    },
});
//#endregion Registrace struktury Booelan

//#region Registrace struktury FlagColor
//#region Registrace serverovych operaci
FilterRegistrations.registerServerOperation("flags", {
    "is": {
        inputs: {
            "input1": {
                condition: "{attrName} in [{value}]",
                conditionalOperation: [
                    { containsValue: "0", separator: ",", condition: "{attrName} = NULL" },
                ],
            },
        },
    },
});
//#endregion Registrace serverovych operaci
FilterRegistrations.registerDataTypeFilter({
    dataType: "flags",
    basicMultiOperation: true,
    groupList: [
        {
            operationList: [
                FilterRegistrations.getIOperation("is", "GUI-690552", [ // Výběr barev
                    FilterRegistrations.getIFilterFieldInfo("input1", "FlagFilter"),
                ]),
            ],
        },
    ],
});
//#endregion Registrace struktury FlagColor

//#endregion Registrace struktur
